import { createFileRoute, redirect } from "@tanstack/react-router"

import { useAuthStore } from "@/stores/authStore"

export const Route = createFileRoute("/admin/")({
  beforeLoad: async () => {
    if (!useAuthStore.getState().hasPermission("view:admin_page")) {
      throw redirect({
        to: "/",
      })
    }
  },
})
